// src/pages/Home.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import './Home.css';

import Testimonials from './Testimonials';

const Home = () => {
  return (
    <main className="page-home">
      {/* Seção 1: Hero */}
      <section className="hero-section">
        <div className="page-content">
          <h1>Inteligência Educacional para o Ensino Superior</h1>
          <p>Conheça a <strong>Plataforma CODI</strong> e transforme dados acadêmicos, pedagógicos e financeiros em <strong>decisões estratégicas</strong>.
            <br/> Automatize alertas e promova processos para a <strong>Gestão do Sucesso e Permanência</strong> na sua instituição.
          </p>
          <Link to="/contato" className="btn btn-primary">Fale Conosco</Link>
        </div>
      </section>
      {/* /Hero */}

      {/* Seção 2: Desafios Principais */}
      <section className="challenges-section">

        <div className="page-content">

          <p className="challenges-text">
            Evasão, inadimplência e baixo desempenho no ENADE não acontecem do dia para a noite.
            <br/>A CODI unifica as informações da sua IES e gera <strong>alertas proativos</strong> para você
            <strong> agir no momento certo</strong> e conquistar melhores resultados.
          </p>

          <div className="challenges-grid">

            <div className="challenge-item evasao">
              <div className="challenge-illustration"></div>
              <h2 className="challenge-title">Evasão</h2>
              <p className="challenge-text">
                A CODI monitora o <strong>Risco de Evasão</strong> de cada aluno e orienta Ações de Permanência com alertas <strong>automatizados</strong>.
                Alguns de nossos clientes aumentaram em <strong>45%</strong> a taxa anual de permanência de forma crescente e progressiva em até 3 anos.
              </p>
              <p className="challenge-text">
                Reduza o <strong>CHURN</strong> e aumente o <strong>YIELD</strong> da sua instituição atuando <strong>proativamente</strong>.
              </p>
              <Link to="/funil" className="btn">Conheça o Funil da Permanência</Link>
            </div>

            <div className="challenge-item inadimplencia">
              <div className="challenge-illustration"></div>
              <h2 className="challenge-title">Inadimplência</h2>
              <p className="challenge-text">
                Impulsione a <strong>saúde financeira</strong> da sua instituição com monitoramento inteligente da
                inadimplência — 30, 60 e 90+ dias — detectando atrasos e antecipando negociações de forma <strong>automatizada</strong>.
              </p>
              <p className="challenge-text">
                Com a CODI, alguns de nossos clientes <strong>reduziram em 47%</strong> a taxa relativa de inadimplência num período de 3 anos, de forma contínua e sustentável.
                { /*
                Cuide da <strong>saúde financeira</strong> da sua instituição com o monitoramento da inadimplência de 30, 60 e acima de 90 dias.
                Detecte atrasos e <strong>antecipe negociações</strong> de forma automatizada.
                Temos clientes que aumentaram a adimplência <strong>de 83% para 91%</strong> e
                outros que reduziram a inadimplência de <strong>4,54% para 3,41%</strong>, ainda assim uma queda de 25%.
                Na sua instituição, a inadimplência pode diminuir <strong>45% em até 3 anos</strong>, com resultados progressivos e sustentáveis.
                */ }
              </p>
              <Link to="/financeiro" className="btn">Saiba mais</Link>
            </div>

            <div className="challenge-item enade">
              <div className="challenge-illustration"></div>
              <h2 className="challenge-title">ENADE</h2>
              <p className="challenge-text">
                <strong>Identifique os alunos</strong> com maior probabilidade de participar do exame em cada ciclo em um horizonte de até 5 anos.
                
              </p>
              <p className="challenge-text">
                Com <strong>indicadores avançados</strong>, estruture ações pedagógicas
                sobre as <strong>disciplinas e conteúdos</strong> que requerem mais atenção.
                Fortaleça o desempenho de cada aluno, do curso e de toda a sua IES.
              </p>
              <Link to="/enade" className="btn">Entenda como</Link>
            </div>

          </div>

        </div>
      </section>
      {/* /Desafios Principais */}

      {/* Seção 1: Testimonials */}
      {/*
      <section className="testimonials-section">
        <div className="page-content">
          <Testimonials />
        </div>
      </section>
      */}
      {/* /Testimonials */}

      {/* Seção 3: Por que a CODI é Diferente? */}
      <section className="why-codi-section">

        <div className="page-content">

          <div className="why-codi-grid">

            <div className="why-codi-item"></div>

            <div className="why-codi-item">
              <h3 className="section-title">Mais que um BI: CRM, BPM e Mensageria em uma só plataforma</h3>
              <ul className="why-codi-list">
                <li>Faça gestão baseada em evidências com análises de <strong>cohort multidimensional</strong></li>
                <li>Automatize processos (alertas, atendimentos, tarefas e fluxos no estilo Kanban)</li>
                <li>Agilize a mensageria (WhatsApp, SMS, e-mail – conforme a API da sua IES)</li>
              </ul>
              <p className="section-text">
                Tenha visão 360° da <strong>Jornada do Aluno</strong> e de toda a instituição.
                A CODI possui recursos de <strong>BI</strong> (relatórios e dashboards relevantes
                de fácil operação), <strong>CRM</strong> (organiza contatos e atendimentos)
                e <strong>BPM</strong> (automatiza processos).
              </p>
              <Link to="/funil" className="btn btn-primary">Veja na prática</Link>
            </div>

          </div>
        </div>
      </section>
      {/* Seção 3: Por que a CODI é Diferente? */}

      {/* Seção 4: Chamado Final */}
      <section className="final-call-section">
        <div className="page-content">

          <h2 className="section-title">Pronto para transformar a gestão na sua IES?</h2>
          <p className="section-text">
            Fale conosco e entenda como a CODI pode ser implantada em poucos dias e com total segurança para
            alavancar os resultados de Permanência, Inadimplência e também do ENADE na sua instituição,
            com ações corretivas e preventivas automatizadas.
          </p>
          <Link to="/contato" className="btn btn-primary">Agende uma demonstração</Link>

        </div>
      </section>
      {/* /Chamado Final */}

    </main>
  );
};

export default Home;
